var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditPasswordForgot.jinja');
require('./MemberProfileEditPasswordForgot.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditPasswordForgot-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditPasswordForgot-buttons-button--save': 'saveEdit',
        'click .MemberProfileEditPasswordForgot-confirmPopup-body-btn': 'cancelEdit',
        'input input': 'onInputChange'
    },


    saveApi: function () {
        return Urls['member:api:forgot']('json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'saveApi');

        Base.prototype.initialize.call(this, options);
    },


    saveEdit: function () {
        var $button = this.$('.MemberProfileEditPasswordForgot-buttons-button--save');

        this.$('.MemberProfileEditPasswordForgot-body-form-input').removeClass('error');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                email: this.$('.MemberProfileEditPasswordForgot-body-form-input').val()
            }),
            success: function (responseData) {
                $button.removeClass('Button--loading');

                this.$('.MemberProfileEditPasswordForgot-confirmPopup').removeClass('hidden');
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    this.$('.MemberProfileEditPasswordForgot-body-form-input').addClass('error');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'passwordForgot');
    },


    onInputChange: function () {
        this.$('.MemberProfileEditPasswordForgot-body-form-input').removeClass('error');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPasswordForgot.js
// module id = 211
// module chunks = 0